/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosCalloutCardFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { ButtonList, CosmosDesc, CosmosTitle, EdsIcon, EdsIconType } from "@components/elements";

const outerStyles = css({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	w: "full",
	h: "full",
	padding: "eds.dimension.48",
	smDown: {
		paddingBlock: "eds.dimension.32",
		paddingInline: "eds.dimension.24",
	},

	"&.page": {
		minHeight: "60vh", //matches app min-height
	},
});

const styles = css({
	borderRadius: "eds.borderRadius.24",
	border: "1px solid token(colors.eds.border.subtle)",
	background: "eds.background.elevated.low.default",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	w: "560px",
	padding: "eds.dimension.48",
	textAlign: "center",
	smDown: {
		padding: "eds.dimension.32",
	},
});

export interface CosmosCallCardProps extends CosmosCalloutCardFragment {
	wholePage?: boolean;
}

export const CosmosCalloutCard = ({
	icon,
	title,
	desc,
	buttons,
	wholePage,
}: CosmosCallCardProps): React.JSX.Element => {
	return (
		<div className={cx("callout-card-outer", wholePage ? "page" : "", outerStyles)}>
			<div className={cx("callout-card", styles)}>
				<VStack justifyContent="center" alignItems="center" gap="eds.dimension.32">
					{icon ? <EdsIcon size="xl" icon={icon as EdsIconType} /> : null}
					<CosmosTitle title={{ ...title, variant: "headingXL" }} />
					<CosmosDesc description={{ html: desc }} />
					<ButtonList buttons={buttons} />
				</VStack>
			</div>
		</div>
	);
};
